import { FilterRole } from "types/FilterRole";
import {
  BaseService,
  ResponseData,
  ServiceOptions,
  prepareParams,
} from "./baseService";

class FilterRoleService extends BaseService<FilterRole> {
  controllerName = "filterrole";

  // Fetches the users that are not already members of that filter role
  async getNonMembers(
    id: number | string,
    options?: ServiceOptions
  ): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();
    const params = prepareParams(options);
    const { data } = await this.api.get<ResponseData<any>>(
      `/${this.controllerName}/availableMembers/${id}`,
      { params }
    );
    return data;
  }
}
export const filterRoleService = new FilterRoleService();
